// Placeholder generator. No backend endpoint exists yet to issue real ticket
// numbers, so this mocks the XX-XX-XXX format described in .claude/CLAUDE.md
// until order submission is wired to a real service.
function randomDigits(length) {
  return Array.from({ length }, () => Math.floor(Math.random() * 10)).join('');
}

export function generateTicketNumber() {
  return `04-01-${randomDigits(3)}`;
}
